module.exports = __webpack_public_path__ + "/images/logo-chicco-it.435fc1e.svg";